import type { ShallowRef } from 'vue'

export function useCallTimers (conferences: ShallowRef<Map<string, ConferenceEntry>>) {
  const callTimers: Map<string, ReturnType<typeof setInterval>> = new Map()

  const startCallTimer = (conferenceId: string) => {
    if (callTimers.has(conferenceId)) { return }
    const timer = setInterval(() => {
      const entry = conferences.value.get(conferenceId)
      if (entry) {
        const updated = new Map(conferences.value)
        updated.set(conferenceId, { ...entry, duration: entry.duration + 1 })
        conferences.value = updated
      }
    }, 1000)
    callTimers.set(conferenceId, timer)
  }

  const stopCallTimer = (conferenceId?: string) => {
    if (conferenceId !== undefined) {
      const timer = callTimers.get(conferenceId)
      if (timer !== undefined) {
        clearInterval(timer)
        callTimers.delete(conferenceId)
      }
    } else {
      callTimers.forEach(t => clearInterval(t))
      callTimers.clear()
    }
  }

  const rekeyTimer = (oldKey: string, newKey: string) => {
    const timer = callTimers.get(oldKey)
    if (timer !== undefined) {
      clearInterval(timer)
      callTimers.delete(oldKey)
      startCallTimer(newKey)
    }
  }

  return { startCallTimer, stopCallTimer, rekeyTimer }
}
